import {
  ContactResponse,
  ContactRequest,
  ContactDM1Response,
  Lookup,
} from 'sigma-mappings';
import translate from '@/services/translate';
import Http from '@/services/http';

/* istanbul ignore next */
const apiFieldDefinitions = {
  Descricao: {
    label: 'sensors.configuration-dm2.description',
  },
};

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
        $MA001: (data) => {
          const returnedField = apiFieldDefinitions[data.field];

          return {
            NomeDoCampo: translate(returnedField.label),
          };
        },
        $MA051: (data) => {
          const returnedField = apiFieldDefinitions[data.field];
          return {
            maxLength: data.parameters[0],
            fieldName: translate(returnedField.label),
          };
       },
     },
    },
  };

const urls = {
  getContactsBySensor: sensorId => `/supervisao/dm1/${sensorId}/configuracoes`,
  updateOrDeleteContact: id => `/supervisao/dm1/configuracoes/${id}`,
  getContactTypesBySensor: sensorId => `/supervisao/dm1/${sensorId}/contatos`,
  getContactById: (sensorId, contactId) => `/supervisao/dm1/${sensorId}/contatos/${contactId}`,
};

export default {
  getContactsBySensor(sensorId) {
    const http = new Http();
    return http.get(urls.getContactsBySensor(sensorId))
      .then(({ data }) => data.map(item => new ContactResponse(item)));
  },
  updateContact(contact) {
    const http = new Http(error);
    const mappedPayload = new ContactRequest(contact);
    return http
      .put(urls.updateOrDeleteContact(contact.id), mappedPayload)
      .then(({ data }) => data);
  },
  deleteContact(id) {
    const http = new Http();
    return http.delete(urls.updateOrDeleteContact(id));
  },
  getContactTypesBySensor(sensorId) {
    const http = new Http();
    return http.get(urls.getContactTypesBySensor(sensorId))
      .then(({ data }) => data.map(item => new Lookup(item)));
  },
  getContactById(sensorId, contactId) {
    const http = new Http();
    return http.get(urls.getContactById(sensorId, contactId))
      .then(({ data }) => new ContactDM1Response(data));
  },
};
